(() => {
  if (window.__wnVideoShopCartBridgeReadyV2) return;
  window.__wnVideoShopCartBridgeReadyV2 = true;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const openCartDrawer = () => {
    const drawer = document.querySelector('#MinimogCartDrawer');

    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    const cartTrigger = document.querySelector(
      '.m-cart-icon-bubble, [data-cart-drawer-trigger], [data-open-cart], a[href="/cart"]'
    );

    if (cartTrigger) {
      cartTrigger.click();
      return true;
    }

    return false;
  };

  const refreshAndOpenDrawer = () => {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { open: true }
    }));

    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { open: true }
    }));

    window.setTimeout(openCartDrawer, 120);
    window.setTimeout(openCartDrawer, 350);
    window.setTimeout(openCartDrawer, 700);
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target && event.target.closest
      ? event.target.closest('.wn-video-shop__form')
      : null;

    if (!form) return;

    // Important: fully stop the normal Shopify form submit so the cart page
    // can never open from this section.
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (form.dataset.wnBridgeAdding === 'true') return;

    const input = form.querySelector('[name="id"]');
    const button = form.querySelector('.wn-video-shop__cart');
    const variantId = input ? Number(input.value) : 0;

    if (!variantId || !button || button.disabled) return;

    form.dataset.wnBridgeAdding = 'true';
    const originalText = button.textContent.trim();

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding...';

    try {
      const addUrl =
        (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart_add_url) ||
        `${root()}cart/add.js`;

      const response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      });

      const data = await response.json();

      if (!response.ok || data.status >= 400) {
        throw new Error(data.description || data.message || 'Unable to add product to cart.');
      }

      button.textContent = 'Added';

      refreshAndOpenDrawer();

      window.setTimeout(() => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = originalText;
      }, 1000);
    } catch (error) {
      console.error('[Wander Nation] Video shop add to cart failed:', error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalText;
    } finally {
      delete form.dataset.wnBridgeAdding;
    }
  }, true);
})();
